<template>
  <div v-if="user.plano && user.plano !== null && user.plano.data_inicio && user.plano.data_final">
    <div
      :class="(moment().diff(user.plano.data_final, 'days') > 0 ? 'error' : 'warning') + ' dark pa-2 white--text text-xs-center'"
      @click="sejaPremium()">
      <template v-if="parseInt(user.plano.revogado) === 1">
        <h3>{{ strings[idioma].assinatura_revogada }}</h3>
      </template>
      <template v-else-if="parseInt(moment().diff(user.plano.data_final, 'days')) === 0">
        <h3>{{ (strings[idioma].plano_vence_hoje) }}</h3>
      </template>
      <template v-else-if="moment().diff(user.plano.data_final, 'days') > 0">
        <h3>{{ (strings[idioma].plano_vencido_ha_dias).format(moment().diff(user.plano.data_final, 'days')) }}</h3>
      </template>
      <template v-else-if="moment().diff(user.plano.data_final, 'days') > -16">
        <h3>{{ (strings[idioma].plano_vencer_ha_dias).format((-1) * (moment().diff(user.plano.data_final, 'days')) + 1) }}</h3>
      </template>
      <template v-if="parseInt(user.plano.revogado) !== 1">
        <template v-if="moment().diff(user.plano.data_final, 'days') < 1">

          <big> {{ (strings[idioma].plano_ativo_de_ate).format(moment(user.plano.data_inicio).format(strings[idioma].formato_datas_sem_hora), moment(user.plano.data_final).format(strings[idioma].formato_datas_sem_hora)) }}</big>
        </template>
        <template v-else>
          <big> {{ (strings[idioma].plano_esteve_ativo_de_ate).format(moment(user.plano.data_inicio).format(strings[idioma].formato_datas_sem_hora), moment(user.plano.data_final).format(strings[idioma].formato_datas_sem_hora)) }}</big>
        </template>
      </template>
      <div id="avisoPremium_descobreTipo">
        <template v-if="user.plano.tipo === 0">
          <p>{{ strings[idioma].seu_plano_premium_e_pecuarista }}</p>
        </template>
        <template v-if="user.plano.tipo === 1">
          <p>{{ strings[idioma].seu_plano_premium_e_start }}</p>
        </template>
        <template v-if="user.plano.tipo === 2">
          <p>{{ strings[idioma].seu_plano_premium_e_consultor }}</p>
        </template>
      </div>
      <template v-if="user.plano.id_empresa !== null && empresaParceiraInfo !== null">
        <a
          :href="empresaParceiraInfo.site"
          target="_blank"
          class="white--text">
          {{ strings[idioma].assinatura_adquirido_por_parceiro }}: <b>{{ empresaParceiraInfo.nome }}</b>
        </a>
      </template>
      <template v-else>
        <a
          target="_blank"
          class="white--text">
          {{ strings[idioma].assinatura_adquirido_por_brcorte }}
        </a>
      </template>
      <div>
        <v-btn
          flat
          dark
          @click="sejaPremium()">
          {{ strings[idioma].clique_e_remove_premium }}
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      empresaParceiraInfo: null
    }
  },
  computed: {
    ...mapState('app', ['idioma', 'strings', 'user', 'empresa', 'acesso'])
  },
  created () {
    if (this.user.plano && this.user.plano.id_empresa !== null) {
      this.getInfoEmpresa(this.user.plano.id_empresa)
    }
  },
  methods: {
    moment (...args) {
      return moment(...args)
    },
    sejaPremium () {
      window.location.href = '/seja-premium'
    },
    async getInfoEmpresa (idEmpresa) {
      try {
        let res = await this.$getInfoEmpresa(idEmpresa)
        this.empresaParceiraInfo = res
      } catch (error) {
        this.empresaParceiraInfo = null
        console.log(error)
      }
    }
  }

}
</script>
